<template>
	<modal
		v-if="!isFetchingAssignPackage"
		size="small-medium"
		:hide-footer="true"
		@close="close">
		<template slot="header">
			<span v-if="assignPackageTotal > 0">{{ $t('List of assigned packages') }}</span>
			<span v-else>{{ $t('Assign Package') }}</span>
		</template>
		<template slot="body">
			<div v-if="assignPackageTotal > 0">
				<!-- form add user -->
				<div class="form-group rundown-collab mt-2 mb-2">
				<label class="typo__label">Users</label>
					<div>
						<multiselect class="rundown-collab-input" v-model="userIds" tag-placeholder="Add User"
						placeholder="Search or add a user" label="name" track-by="id"
						:options="filteredAssignUser"  :multiple="true" :searchable="true" :show-labels="false">
						<template slot="singleLabel" slot-scope="props">
							<span>{{ props.option.name }}</span>
						</template>
						<template slot="option" slot-scope="props">
							<div class="d-flex justify-content-between"><span>{{ props.option.name }}</span><span>{{ props.option.email }}</span></div>
						</template>
						<span class="arrow-multiselect" slot="caret">
							<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
						</span>
						<span slot="noResult">Oops! No Users found.</span></multiselect>
					</div>
				</div>
				<!-- end date -->
				<div class="col-md-12 pl-0 pr-0">
					<div class="form-group">
						<label>{{ $t('Expired Date') }}</label>
						<flat-pickr
							class="date-event form-control"
							:config="configDateTimePicker"
							v-model="endDate"
						/>
					</div>
				</div>
				<button
					@click="addExisting"
					:disabled="endDate === '' || startDate === ''"
					type="submit"
					class="btn btn-submit btn-primary mt-1 mb-1"
					:class="{ 'is-loading': isSaving }">
					<span>{{ $t('Assign Package') }}</span>
				</button>
				<hr class="mb-3">
				<div id="styleScroll1" class="list-group list-quotation-wrapper mb-1">
					<div v-for="item in assignPackages" :key="item.id">
						<div>
							<a class="list-group-item text-decoration-none pointer pt-3">
								<div class="d-flex justify-content-between">
									<div class="d-flex"><h5 class="mr-1">{{item && item.user && item.user.name ? item.user.name : ''}}</h5></div>
									<div class="d-flex">
										<!-- <div @click.stop="activateAssignePackage(item)">
											<mdIcon class="feature-icon-edit-active" v-tooltip="'Confirm'" v-if="item.is_active">check_circle_outline</mdIcon>
											<mdIcon class="feature-icon-edit" v-tooltip="'Unconfirm'" v-if="!item.is_active">check_circle_outline</mdIcon>
										</div> -->
										<div @click.stop="confirmRemoveItem(item)">
											<mdIcon  class="feature-icon-delete" v-tooltip="'Delete'">cancel</mdIcon>
										</div>
									</div>
								</div>
								<div>
									<!-- active -->
									<label v-if="item.is_active" class="text-secondary mr-1 mb-0">{{ $t('This Package is') }}</label>
									<span v-if="item.is_active" class="text-primary mb-0">active</span>
									<label v-if="item.is_active" class="text-secondary ml-1 mr-1 mb-0">{{ $t('from') }}</label>
									<span v-if="item.is_active" class="text-primary mb-0">{{getStartDate(item)}}</span>
									<label v-if="item.is_active" class="text-secondary ml-1 mr-1 mb-0">{{ $t('to') }}</label>
									<span v-if="item.is_active" class="text-primary mb-0">{{getEndDate(item)}}</span>
									<!-- non active -->
									<label v-if="!item.is_active" class="text-secondary mr-1 mb-0">{{ $t('This Package is') }} </label><span v-if="!item.is_active" class="text-primary">non active</span>
									<!-- confirm -->
									<div v-if="item.is_read">
										<label class="text-secondary mr-1">({{item && item.user && item.user.name ? item.user.name : ''}} has been </label>
										<span v-if="item.is_confirm">{{ $t('accept ') }}</span>
										<!-- non confirm -->
										<label v-else class="text-primary mr-1">{{ $t('decline ') }}</label>
										<span class="text-secondary">{{ $t('the quotations') }})</span>
									</div>
								</div>
							</a>
						</div>
					</div>
					<div v-if="!isFetchingAssignPackage && assignPackages.length === 0" class="text-center">
						{{ $t('You have not added any promo code yet') }}
					</div>
				</div>
			</div>
			<div v-else>
				<form @submit.prevent="save">
					<!-- User Ids -->
					<div class="form-group rundown-collab">
						<label class="typo__label">Users</label>
							<div v-if="assignPackageTotal > 0" class="disabled">
								<multiselect class="rundown-collab-input" v-model="userIds" tag-placeholder="Add User"
								placeholder="Search or add a user" label="name" track-by="id"
								:options="filteredUser"  :multiple="true" :searchable="true" :show-labels="false">
								<template slot="singleLabel" slot-scope="props">
									<span>{{ props.option.name }}</span>
								</template>
								<template slot="option" slot-scope="props">
									<div class="d-flex justify-content-between"><span>{{ props.option.name }}</span><span>{{ props.option.email }}</span></div>
								</template>
								<span class="arrow-multiselect" slot="caret">
									<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
								</span>
								<span slot="noResult">Oops! No Users found.</span></multiselect>
							</div>
							<div v-else>
								<multiselect class="rundown-collab-input" v-model="userIds" tag-placeholder="Add User"
								placeholder="Search or add a user" label="name" track-by="id"
								:options="filteredUser"  :multiple="true" :searchable="true" :show-labels="false">
								<template slot="singleLabel" slot-scope="props">
									<span>{{ props.option.name }}</span>
								</template>
								<template slot="option" slot-scope="props">
									<div class="d-flex justify-content-between"><span>{{ props.option.name }}</span><span>{{ props.option.email }}</span></div>
								</template>
								<span class="arrow-multiselect" slot="caret">
									<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
								</span>
								<span slot="noResult">Oops! No Users found.</span></multiselect>
							</div>
						</div>
					<!-- start date -->
					<!-- <div class="col-md-12 pl-0 pr-0">
						<div class="form-group">
							<label>{{ $t('Start date') }}</label>
							<flat-pickr
								class="date-event form-control"
								:class="{'disabled': assignPackageTotal > 0}"
								:config="configDateTimePicker"
								v-model="startDate"
							/>
						</div>
					</div> -->
					<!-- end date -->
					<div class="col-md-12 pl-0 pr-0">
						<div class="form-group">
							<label>{{ $t('Expired Date') }}</label>
							<flat-pickr
								:class="{'disabled': assignPackageTotal > 0}"
								class="date-event form-control"
								:config="configDateTimePicker"
								v-model="endDate"
							/>
						</div>
					</div>
					<button
						:disabled="endDate === '' || startDate === ''"
						type="submit"
						class="btn btn-submit btn-primary mt-3"
						:class="{ 'is-loading': isSaving }">
						<span v-if="assignPackageTotal > 0">{{ $t('Assign Package') }}</span>
						<span v-else>{{ $t('Assign Package') }}</span>
					</button>
				</form>
			</div>
			<modal
				@close="isConfirmRemoveVisible = false"
				v-if="isConfirmRemoveVisible && selectedAssignePackage">
				<template slot="header">
					<h3>{{ $t('Remove Promo Code') }}</h3>
				</template>
				<template slot="body">
					{{ $t('Are you sure want to delete') }} {{ selectedAssignePackage.name }}?
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button
							class="btn btn-primary"
							:class="{ 'is-loading': isRemoving }"
							@click="removeItem(selectedAssignePackage)">
							{{ $t('Remove') }}
						</button>
						<button
							class="btn btn-default"
							@click="isConfirmRemoveVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
		</template>
		<!-- Delete Confirmation -->
	</modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import { getAxiosErrorMessage, convertTimezone } from '@/lib/helper';
import assignPackagesApi from '@/api/assign-packages';
import usersApi from '@/api/user';

export default {
	name: 'ModalAddQuotation',
	props: {
		data: {
			type: Object,
		},
		userParent: {
		},
		mineRole: {
			type: String,
		},
	},
	components: {
		Modal,
		Multiselect,
		flatPickr,
	},
	data() {
		return {
			endDate: '',
			startDate: '',
			isSaving: false,
			users: [],
			userIds: [],
			isFetching: false,
			isFetchingAssignPackage: false,
			assignPackages: null,
			configDateTimePicker: {
				enableTime: false,
				dateFormat: 'Y-m-d',
				minDate: 'today',
			},
			isConfirm: false,
			isActivateAssigne: false,
			selectedAssignePackage: null,
			isConfirmRemoveVisible: false,
			isRemoving: false,
		};
	},
	methods: {
		fetchUser() {
			this.isFetching = true;
			const callback = (response) => {
				const items = response.data;
				this.users = items;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'User',
					text: message,
				});
				this.isFetching = false;
			};
			const paramsUser = {
				page: 1,
				limit: 1000,
				order_by: 'id',
				sort_by: 'asc',
				role: 'client',
			};
			usersApi.getUsers(paramsUser, callback, errorCallback);
		},
		addTag() {
			this.users.push();
			this.userIds.push();
		},
		save() {
			this.isSaving = true;
			const params = this.params;
			const callback = (response) => {
				// const user = response.data;
				const message = response.message;
				// this.$emit('saved', user);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add User',
					text: message,
				});
				this.isSaving = false;
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add User',
					text: message,
				});
				this.isSaving = false;
			};
			const paramsUpdate = {
				is_confirm: this.isConfirm,
			};
			if (this.assignPackageTotal > 0) {
				assignPackagesApi.update(this.assignPackages.id, paramsUpdate, callback, errorCallback);
			} else {
				assignPackagesApi.create(params, callback, errorCallback);
			}
		},
		addExisting() {
			this.isSaving = true;
			const params = this.params;
			const callback = (response) => {
				// const user = response.data;
				const message = response.message;
				// this.$emit('saved', user);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add User',
					text: message,
				});
				this.isSaving = false;
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add User',
					text: message,
				});
				this.isSaving = false;
			};
			assignPackagesApi.create(params, callback, errorCallback);
		},
		close() {
			this.$emit('close');
		},
		initData() {
			this.reset();
			if (this.data) {
				this.fetchAssignPackage(this.data);
			}
		},
		fetchAssignPackage(data) {
			this.isFetchingAssignPackage = true;
			const callback = (response) => {
				const items = response.data;
				this.assignPackages = items;
				this.isFetchingAssignPackage = false;
				// this.setData(this.assignPackages);
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'User',
					text: message,
				});
				this.isFetchingAssignPackage = false;
			};
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'id',
				sort_by: 'asc',
				package_id: data.id,
			};
			assignPackagesApi.getList(params, callback, errorCallback);
		},
		confirmRemoveItem(item) {
			this.selectedAssignePackage = item;
			this.isConfirmRemoveVisible = true;
		},
		removeItem(item) {
			this.isRemoving = true;
			const callback = (response) => {
				const index = this.assignPackages.findIndex(({ id }) => id === item.id);
				if (index !== -1) {
					this.assignPackages.splice(index, 1);
				}
				this.isRemoving = false;
				this.isConfirmRemoveVisible = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Remove Promos',
					text: response.message,
				});
			};
			const errorCallback = () => {
				this.isRemoving = false;
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Remove Promos',
					text: 'Failed delete user',
				});
			};
			assignPackagesApi.delete(item.id, callback, errorCallback);
		},
		reset() {
			this.endDate = '';
			const today = new Date();
			const date = `${today.getFullYear()}-${(today.getMonth() + 1)}-${today.getDate()}`;
			this.startDate = date;
			this.userIds = '';
		},
		setData(assignPackages) {
			if (assignPackages) {
				const users = assignPackages;
				if (users.length > 0) {
					const userObj = [];
					for (let index = 0; index < users.length; index++) {
						const user = users[index].user;
						const userResult = user;
						userObj.push(userResult); // eslint-disable-line no-param-reassign
						this.userIds = userObj;
					}
				}
			}
		},
		getRelativeTime(item) {
			let time = '-';
			if (item) {
				if (!item.timezone) {
					time = item;
					time = new Date(time);
					const result = `${time.getDate()}-${(time.getMonth() + 1)}-${time.getFullYear()}`;
					time = result;
				} else {
					time = convertTimezone(item, item.timezone);
				}
			}
			return time;
		},
		getStartDate(item) {
			const assignedPackage = item.start_date;
			return this.getRelativeTime(assignedPackage);
		},
		getEndDate(item) {
			const assignedPackage = item.end_date;
			return this.getRelativeTime(assignedPackage);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		userId() {
			return this.user && this.user.id ? this.user.id : '';
		},
		params() {
			const users = [];
			for (let index = 0; index < this.userIds.length; index++) {
				const id = this.userIds[index].id;
				users.push(id);
			}
			// const access = this.access;
			const params = {
				package_id: this.data && this.data.id ? this.data.id : '',
				start_date: this.startDate,
				end_date: this.endDate,
				user_ids: JSON.stringify(users),
			};
			return params;
		},
		filteredUser() {
			const filter = item => (item.is_disabled !== 1);
			return this.users.filter(filter);
		},
		filteredAssignUser() {
			const filter = (({ id }) => {
				const isPicked = this.assignPackages.findIndex(item => item.user_id && item.user_id === id) !== -1;
				return !isPicked;
			});
			return this.users.filter(filter);
		},
		assignPackageTotal() {
			return this.assignPackages.length;
		},
	},
	created() {
		this.fetchUser();
		this.initData();
	},
};
</script>
